import checkRange from "./check-range";

function formFadedOverlay($elem) {
  $elem.on("click", function (e) {
    let target = $(e.target);

    if (
      target.is("input") ||
      target.is("select") ||
      target.is("textarea") ||
      checkRange($elem, e.pageY)
    ) {
      $elem.addClass("shown");
    }
  });
}

export default formFadedOverlay;
